module.exports = __webpack_public_path__ + "img/accor-services.5b781b12.png";